import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import EditIcon from "@mui/icons-material/Edit";
import EditTableModal from "./EditTableModal";

import ConfirmDeleteModal from "../../../Components/Common/ConfirmDeleteModal";
// import FormControl from "@mui/material/FormControl";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AddIcon from "@mui/icons-material/Add";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContentText from "@mui/material/DialogContentText";

import { useDispatch, useSelector } from "react-redux";
import "./style.css";
import { Column, columnDef } from "./Columns";
import MuiPagination from "@mui/material/Pagination";
import { TablePaginationProps } from "@mui/material/TablePagination";
import {
  DataGrid,
  GridColDef,
  GridCellParams,
  GridFooterContainer,
  GridPagination,
  GridPreProcessEditCellProps,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import {
  AddOrDeleteColumn,
  handleAddNewRow,
  processingRowUpdate,
} from "../../../Utils/rowUtils";

const LTDemandTable = forwardRef((props: any, ref: any) => {
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  /**Redux state */
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId
  );

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable
  );

  const columns: readonly Column[] = columnDef;
  const dispatch: any = useDispatch();
  // const [rows, setRows] = React.useState<any>([]);
  const [confirmDelete, setConfirmDelete] = React.useState(false);
  const [deleteRowId, setDeleteRowId] = React.useState({ id: "" });
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isOpenEditModal, setIsOpenEditModal] = React.useState(false);
  const [editedData, setEditedData] = React.useState({});
  const [updatedVal, setUpdatedVal] = React.useState<any>(editedData);
  const [resetValues, setResetValues] = React.useState({
    net_Weight: 0,
    designed_Speed: 0,
  });
  const [editedTableData, setEditedTableData] = React.useState<any>([]);
  const { dashboardSummaryCost, isDone, isLoading, uploadMasterFileMessage } =
    useSelector((state: any) => state.InputDataReducers);

  useImperativeHandle(ref, () => ({
    ClearEditedData() {
      setEditedTableData([]);
    },
  }));

  useEffect(() => {
    setIsProcessed(props.isProcessed);
    // props.setRows(props.rowsData);
    props.handleGetEditData(editedTableData);
  }, [props.rowsData, editedTableData]);

  const isEditable = (params: any) => {
    return !!params.row.isNew;
  };

  const handleClickOpenDeleteModal = (id: any) => {
    setDeleteRowId(id);
    setConfirmDelete(true);
    // deleteInMainId = id;
  };

  const handleCloseDelete = () => {
    setConfirmDelete(false);
    // deleteInMainId = "";
  };

  const handleonDelete = () => {
    if (deleteRowId) {
      props.setRows((prev: any[]) => {
        const rowToDelete = prev.find((row) => row.id === deleteRowId.id);
        if (rowToDelete) {
          const updatedRow = {
            ...rowToDelete,
            folder_id: 0,
            folder_Id: 0,
            scenario_id: 0,
          };

          setEditedTableData((prevEditedData: any[]) => [
            ...prevEditedData,
            updatedRow,
          ]);

          return prev.filter((row) => row.id !== deleteRowId);
        }

        return prev; // If no row is found, return the previous rows
      });
    }

    // Close the delete confirmation modal
    setConfirmDelete(false);
    setDeleteRowId({ id: "" });
  };

  // const DeleteRowModal = () => {
  //   return (
  //     <React.Fragment>
  //       <Dialog
  //         open={confirmDelete}
  //         // TransitionComponent={Transition}
  //         keepMounted
  //         onClose={handleCloseDelete}
  //         aria-describedby="alert-dialog-slide-description"
  //       >
  //         {/* <DialogTitle>{'Delete Constrains confirmation'}</DialogTitle> */}
  //         <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
  //           Confirmation for Delete
  //         </DialogTitle>
  //         <DialogContent>
  //           <DialogContentText id="alert-dialog-slide-description">
  //             Do you want to delete this row?
  //           </DialogContentText>
  //         </DialogContent>
  //         <DialogActions>
  //           <Button onClick={handleCloseDelete}>Cancel</Button>
  //           <Button onClick={handleDeleteMain}>Proceed</Button>
  //         </DialogActions>
  //       </Dialog>
  //     </React.Fragment>
  //   );
  // };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleEditMaster1TableRow = (e: any, row: any) => {
    setResetValues({
      net_Weight: row?.net_Weight,
      designed_Speed: row?.designed_Speed,
    });
    setIsOpenEditModal(true);
    setEditedData(row);
  };

  const handleChangeEditValue = (e: any) => {
    setUpdatedVal({
      ...editedData,
      ...updatedVal,
      [e.target.name]: e.target.value,
    });
  };

  const UpdateTableRow = () => {};

  const closeEditModal = (e: any) => {
    setIsOpenEditModal(false);
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);
  const handleCloseSnackbar = () => setSnackbar(null);

  const processRowUpdate = (newRow: any) => {
    processingRowUpdate(newRow, editedTableData, setEditedTableData);
  };

  const tableColumns: GridColDef[] = [
    {
      field: "demand_Location_Code",
      headerName: "Demand Location Code",
      width: 160,
      align: "left",
      headerAlign: "left",
      editable: isEditEnabled,
      headerClassName: "super-app-theme--cell-header",
      cellClassName: "super-app-theme--cell-normal",
      hideable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "demand_Location_Description",
      headerName: "Demand Location Description",
      width: 240,
      align: "left",
      headerAlign: "left",
      editable: isEditEnabled,
      headerClassName: "super-app-theme--cell-header",
      cellClassName: "super-app-theme--cell-normal",
      hideable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "product_Code",
      headerName: "Product Code",
      width: 150,
      align: "left",
      headerAlign: "left",
      editable: isEditEnabled,
      headerClassName: "super-app-theme--cell-header",
      cellClassName: "super-app-theme--cell-normal",
      hideable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "product_Description",
      headerName: "Product Description",
      width: 160,
      align: "left",
      headerAlign: "left",
      editable: isEditEnabled,
      headerClassName: "super-app-theme--cell-header",
      cellClassName: "super-app-theme--cell-normal",
      hideable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "time_Period",
      headerName: "Time Period",
      width: 160,
      align: "left",
      headerAlign: "left",
      editable: isEditable({ row: { isNew: true } }),
      headerClassName: "super-app-theme--cell-header",
      cellClassName: "super-app-theme--cell-normal",
      hideable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "demand_Vol",
      headerName: "Demand Vol",
      width: 160,
      type: "number",
      align: "left",
      headerAlign: "left",
      editable: isEditEnabled,
      headerClassName: "super-app-theme--cell-header",
      cellClassName: "super-app-theme--cell",
      hideable: false,
      sortable: false,
      flex: 1,
      preProcessEditCellProps(params) {
        const invalid =
          params.props.value === null || params.props.value === ""
            ? true
            : false;
        if (invalid) {
          setSnackbar({
            children: "Please enter a valid number!",
            severity: "error",
          });
        }
        return { ...params.props, error: invalid };
      },
    },
    {
      field: "sales_price",
      headerName: "Sales Price",
      width: 160,
      type: "number",
      align: "left",
      headerAlign: "left",
      editable: isEditEnabled,
      headerClassName: "super-app-theme--cell-header",
      cellClassName: "super-app-theme--cell",
      hideable: false,
      sortable: false,
      flex: 1,
      preProcessEditCellProps(params) {
        const invalid =
          params.props.value === null || params.props.value === ""
            ? true
            : false;
        if (invalid) {
          setSnackbar({
            children: "Please enter a valid number!",
            severity: "error",
          });
        }
        return { ...params.props, error: invalid };
      },
    },
    {
      field: "actions",
      headerName: "Action",
      sortable: false,
      width: 150,
      renderCell: (params: any) => {
        return (
          <>
            {AddOrDeleteColumn(
              params,
              props,
              isEditEnabled,
              handleClickOpenDeleteModal,
              handleAddNewRow
            )}
          </>
        );
      },
    },
  ];

  const tableData = {
    columns: tableColumns,
    rows: props.rowsData,
    initialState: {
      columns: {
        columnVisibilityModel: {
          id: false,
        },
      },
    },
    experimentalFeatures: {
      ariaV7: true,
    },
  };

  function Pagination({
    page,
    onPageChange,
    className,
  }: Pick<TablePaginationProps, "page" | "onPageChange" | "className">) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <MuiPagination
        color="primary"
        className={className}
        count={pageCount}
        page={page + 1}
        onChange={(event, newPage) => {
          onPageChange(event as any, newPage - 1);
        }}
      />
    );
  }

  const CustomPagination = (props: any) => {
    return <GridPagination ActionsComponent={Pagination} {...props} />;
  };
  const MyCustomNoRowsOverlay = () => (
    <div className="nodata-display-lable">No Data to Display.</div>
  );
  const Footer = () => {
    return (
      <GridFooterContainer>
        <Box sx={{ flexGrow: 1 }}>
          <Button disabled={tableData.rows.length === 0}>Add Row</Button>
          <CustomPagination />
        </Box>
      </GridFooterContainer>
    );
  };

  return (
    <>
      {isOpenEditModal && (
        <EditTableModal
          isOpen={isOpenEditModal}
          editedData={editedData}
          // payloadData={[selectedUsecaseId, selectedCategoryId, selectedFolderId, selectedScenarioId]}
          resetValues={resetValues}
          UpdateTableRow={UpdateTableRow}
          onClose={closeEditModal}
          handleChangeEditValue={handleChangeEditValue}
          headerName="Manufacturing Master Table"
        />
      )}
      {confirmDelete && (
        <ConfirmDeleteModal
          confirmDelete={confirmDelete}
          handleCloseDelete={handleCloseDelete}
          handleOnDelete={handleonDelete}
        />
      )}
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <DataGrid
          processRowUpdate={processRowUpdate}
          editMode="row"
          density="compact"
          {...(isEditEnabled && { checkboxSelection: true })}
          checkboxSelectionWidth={50}
          sx={{
            "& .MuiDataGrid-checkboxInput": {
              width: "30px", // Set the width of the checkbox itself
            },
            "& .MuiDataGrid-columnHeader--checkbox": {
              width: "50px", // Set the width of the checkbox column header
              minWidth: "50px", // Ensure the column doesn't shrink below this width
            },
            "& .MuiDataGrid-cell--checkbox": {
              width: "50px", // Set the width of the checkbox column cells
              minWidth: "50px",
            },
          }}
          rowSelectionModel={props.selectedRows || []}
          onRowSelectionModelChange={(newSelection: any) => {
            props.handleSelectionChange(newSelection);
          }}
          {...tableData}
          initialState={{
            ...tableData.initialState,
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          showColumnVerticalBorder
          showCellVerticalBorder
          disableColumnSelector
          disableColumnMenu
          pagination
          slots={{
            // footer: Footer,
            pagination: CustomPagination,
            noRowsOverlay: MyCustomNoRowsOverlay,
            //toolbar: CustomToolbar,
          }}
          hideFooterSelectedRowCount
          disableRowSelectionOnClick
          className="data-grid-mui"
        />
      </Paper>
      {!!snackbar && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleCloseSnackbar}
          autoHideDuration={6000}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
      )}
    </>
  );
});

export default LTDemandTable;
